import type { SourcingEventDto } from "../../../autogen/bff-api";
import { isFoaNationalTier } from "../../sourcing-events/buyer/wizard/utils/karens";
import { citesFoaProvisions } from "../../sourcing-events/buyer/wizard/utils/publicProcurementOptions";

export type ClarificationRule = "FOA_PART_II" | "FOA_PART_III" | "UNCITED";

// FOA § 9-3 lets a Part II dialogue cover every side of the tenders; § 23-5 limits Part III to clarifying them.
export const clarificationRuleOf = (event: SourcingEventDto | undefined): ClarificationRule => {
  const ctx = event?.eventContext;
  if (ctx?.type !== "Public" || !citesFoaProvisions(ctx.regulation)) return "UNCITED";
  return isFoaNationalTier(ctx.regulation, ctx.foaPart) ? "FOA_PART_II" : "FOA_PART_III";
};
